import { render, staticRenderFns } from "./ConfirmRegistry.vue?vue&type=template&id=4dbf07c4&scoped=true&"
import script from "./ConfirmRegistry.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf07c4",
  null
  
)

export default component.exports